<template>
  <a-select
    :disabled="disabled"
    :multiple="false"
    :placeholder="placeholder"
    :value="value"
    allow-clear
    option-filter-prop="title"
    show-search
    @change="onChange"
    :virtual="false"
  >
    <a-select-option v-for="item in records" :key="item.id" :title="item.name" :value="item.id">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { defineComponent, onMounted, watch, defineExpose } from "vue";
import { SubcontractPaymentService } from "@/views/subcontract-management/subcontract-payment/subcontract-payment.service";
import { SubcontractApplySimpleListReq } from "@/views/subcontract-management/subcontract-payment/subcontract-payment.interface";

/**
 * 分包付款申请-付款合同下拉选择器
 *
 * 使用方式:
 * <subcontract-apply-select v-model:value="formRef.contractId"></subcontract-apply-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "SubcontractApplySelect",
  props: {
    value: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },
    subcontractStatus: {
      type: String,
      required: true,
    },
    supplierCooperationCompanyId: {
      type: String,
      required: true,
    },
    addRightBizType: {
      type: String,
      default: undefined,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const { data: records, run, loading } = SubcontractPaymentService.useContractSimpleListApi();
    const onChange = async (id) => {
      const target = (records.value || []).find((r) => r.id === id);
      emit("update:value", id);
      emit("change", target);
    };
    watch(
      () => props.supplierCooperationCompanyId,
      async (newVal) => {
        if (!newVal) {
          records.value = [];
        } else {
          const req = new SubcontractApplySimpleListReq();
          req.merge({
            subcontractStatus: props.subcontractStatus,
            supplierCooperationCompanyId: newVal,
            addRightBizType:props.addRightBizType
          });
          await run(req);
        }
      },
      { immediate: true, deep: true }
    );

     defineExpose({ onChange });


    return {
      records,
      loading,
      onChange,
    };
  },

});
</script>
